import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Swal from "sweetalert2";
import axios from "axios";
import { getAuthCredentials } from "../../../utils/auth";

const AddNotif = ({ open, onClose, onSuccess }) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [imgUrl, setImgUrl] = useState("");
  const [loading, setLoading] = useState(false);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const validTypes = ["image/png", "image/jpeg", "image/webp"];
    if (!validTypes.includes(file.type)) {
      Swal.fire(
        "Invalid File",
        "Only PNG, JPEG, and WEBP images are allowed.",
        "error"
      );
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      setImgUrl(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const { token, posId } = await getAuthCredentials();
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/v1/api/notification/create`,
        { name, description, imgUrl, posId },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      Swal.fire("Success", "Notification created.", "success");
      setName("");
      setDescription("");
      setImgUrl("");
      onClose();
      if (onSuccess) onSuccess();
    } catch (err) {
      onClose();
      Swal.fire(
        "Error",
        err?.response?.data?.message || "Creation failed.",
        "error"
      ).then(() => onClose(true));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={() => onClose()} maxWidth="sm" fullWidth>
      <DialogTitle>Add Notification</DialogTitle>
      <DialogContent>
        <TextField
          label="Name"
          fullWidth
          value={name}
          onChange={(e) => setName(e.target.value)}
          margin="normal"
        />
        <Box marginY={2}>
          <ReactQuill
            theme="snow"
            value={description}
            onChange={setDescription}
            placeholder="Enter description here..."
            modules={{
              toolbar: [
                ["bold", "italic", "underline"],
                [{ list: "bullet" }],
                [{ align: [] }],
              ],
            }}
            formats={["bold", "italic", "underline", "list", "bullet", "align"]}
            style={{ height: "200px" }}
          />
        </Box>

        <Box mt={6}>
          <Typography variant="subtitle2">
            Upload Image (PNG, JPEG, WEBP):
          </Typography>
          <input
            type="file"
            accept="image/png, image/jpeg, image/webp"
            onChange={handleImageUpload}
            style={{ marginTop: 8 }}
          />
          {imgUrl && (
            <Box mt={2}>
              <Typography variant="subtitle2">Preview:</Typography>
              <img
                src={imgUrl}
                alt="Preview"
                style={{ maxWidth: "100%", maxHeight: 200 }}
              />
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()} disabled={loading}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={loading}
          startIcon={loading ? <CircularProgress size={18} /> : null}
        >
          {loading ? "Adding..." : "Add"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddNotif;
